export default __webpack_public_path__ + "media/images/close_tab_white-2270fc6a8cdec3af40fe9f96cd935197.png";